module.exports = __webpack_public_path__ + "img/Titan_Logo.4c096680.svg";